import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { materialDark as prismTheme } from 'react-syntax-highlighter/dist/esm/styles/prism';
import {
  findLangByFileExtension,
  parseLangExtension,
} from '#/lib/codemirror/lib/langs';
import { cn } from '#/utils/styles';

export interface ChatCodeBlockProps {
  /**
   * The class name of the code block.
   */
  className?: string;
  /**
   * The code to display.
   */
  code: string;
  /**
   * The language of the code.
   */
  language?: string;
  /**
   * The file path of the code.
   */
  filePath?: string;
}

function ChatCodeBlock({
  code,
  language,
  filePath,
  className,
  ...rest
}: ChatCodeBlockProps) {
  const lang = React.useMemo(() => {
    if (language) {
      return language;
    }

    if (filePath) {
      return findLangByFileExtension(parseLangExtension(filePath));
    }

    return undefined;
  }, [language, filePath]);

  return (
    <SyntaxHighlighter
      {...rest}
      className={cn(className, 'relative z-0', lang && `language-${lang}`)}
      PreTag='div'
      language={lang}
      style={prismTheme}
      // biome-ignore lint/correctness/noChildrenProp: ignore
      children={code}
    />
  );
}

export default ChatCodeBlock;
